<template>
    <tbody v-if="sortedDefinitions.length > 0" class="custom-field-rows">
        <tr v-for="definition in sortedDefinitions" :key="'customField' + definition.id">
            <th>
                <label class="label">
                    {{ definition.label }}<span v-if="definition.required" class="has-text-danger">*</span>:
                </label>
            </th>
            <td>
                <input
                    v-if="definition.type === 'text'"
                    type="text"
                    class="input"
                    :value="value[definition.fieldKey]"
                    @input="setValue(definition, $event.target.value)"
                />
                <textarea
                    v-else-if="definition.type === 'textarea'"
                    class="textarea"
                    rows="3"
                    :value="value[definition.fieldKey]"
                    @input="setValue(definition, $event.target.value)"
                ></textarea>
                <input
                    v-else-if="definition.type === 'number'"
                    type="number"
                    step="any"
                    class="input"
                    :value="value[definition.fieldKey]"
                    @input="setValue(definition, $event.target.value === '' ? null : $event.target.value)"
                />
                <input-date
                    v-else-if="definition.type === 'date'"
                    :value="value[definition.fieldKey]"
                    @input="input => setValue(definition, input)"
                />
                <label v-else-if="definition.type === 'boolean'" class="checkbox">
                    <input
                        type="checkbox"
                        :checked="value[definition.fieldKey] === true"
                        @change="setValue(definition, $event.target.checked)"
                    />
                </label>
                <multiselect
                    v-else-if="definition.type === 'select'"
                    :options="definition.options || []"
                    :value="value[definition.fieldKey] || null"
                    class="is-shorter"
                    placeholder="Auswählen"
                    @input="input => setValue(definition, input || null)"
                >
                    <span slot="caret" ></span>
                    <div
                        slot="clear"
                        class="multiselect__clear"
                        v-if="value[definition.fieldKey]"
                        v-on:click.prevent.stop="setValue(definition, null)"
                    ></div>
                </multiselect>
                <multiselect
                    v-else-if="definition.type === 'multiselect'"
                    :options="definition.options || []"
                    :value="value[definition.fieldKey] || []"
                    class="is-shorter"
                    multiple
                    placeholder="Auswählen"
                    @input="input => setValue(definition, input || [])"
                >
                    <span slot="caret" ></span>
                </multiselect>
                <p v-if="errors && errors[definition.fieldKey]" class="help is-danger">{{ errors[definition.fieldKey] }}</p>
            </td>
        </tr>
    </tbody>
</template>

<script>
import Multiselect from "@components/form/Multiselect";
import InputDate from "@components/form/InputDate";

export default {
    props: {
        // Map {fieldKey: wert}
        value: { type: Object, required: true },
        definitions: { type: Array, default: () => [] },
        errors: { type: Object, default: () => ({}) },
    },

    computed: {
        sortedDefinitions() {
            return [...this.definitions].sort((a, b) => a.position - b.position);
        },
    },

    methods: {
        setValue(definition, input) {
            this.$emit('input', {...this.value, [definition.fieldKey]: input});
        },
    },

    components: {
        Multiselect,
        InputDate,
    }
}
</script>
